var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: {
        disabled: _vm.disabled,
        title: _vm.title,
        empty: _vm.items.length === 0,
        button_add: true,
      },
      on: { click_add: _vm.click_add },
    },
    [
      _c("r-card-album-table", {
        ref: "table",
        attrs: { items: _vm.values, toolbar: false },
        on: {
          "update:items": function ($event) {
            _vm.values = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }